'use client'

import { useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { Link } from '@/i18n/routing'
import { analytics } from '@/lib/analytics'
import { IconArrowRight } from '@tabler/icons-react'

export function PublicLevelViewed({
  system,
  level
}: {
  system: 'hsk' | 'tocfl'
  level?: number
}) {
  useEffect(() => {
    if (system === 'hsk') analytics.hskPageViewed(level)
    else analytics.tocflPageViewed(level)
  }, [system, level])

  return null
}

export function PublicLevelStudyButton({
  system,
  level,
  href,
  label = 'Study this list'
}: {
  system: 'hsk' | 'tocfl'
  level: number
  href: string
  label?: string
}) {
  return (
    <Button asChild>
      <Link
        href={href}
        onClick={() => {
          if (system === 'hsk') analytics.publicHskStudyClicked(level)
          else analytics.publicTocflStudyClicked(level)
        }}
      >
        {label}
        <IconArrowRight className="h-4 w-4" />
      </Link>
    </Button>
  )
}
